angular.module('appMarketplace')
    .directive('sessionExpired', ['$window', '$stateParams', 'NotificationService', 'PasswordService', 'NavigationService',
                                 'UrlService', 'AuthService',
                                 function ($window, $stateParams, NotificationService, PasswordService, NavigationService,
                                           UrlService, AuthService) {
        return {
            restrict: 'E',
            scope: {
                promise: '='
            },
            link: function (scope, element, attrs) {
                scope.loginUrl = UrlService.createAbsoluteUrl('/useradmin/login.html');

                scope.init = function () {
                    NavigationService.getResolvedCurrentAccount(function successCallback(currentAccount) {
                        scope.currentAccount = currentAccount;
                    }, function errorCallback() {
                        // not authorized and we know nothing about previous session
                        $window.location.href = scope.loginUrl;
                    });

                    scope.window = angular.element("#sessionExpiredForm").kendoWindow({
                        actions: [],
                        modal: true,
                        pinned: true,
                        resizable: false,
                        title: "Session expired",
                        width: "360px",
                        visible: false,
                        autoFocus: false,
                        close: function () {
                            element.remove();
                            scope.$destroy();
                        },
                        deactivate: function (e) {
                            scope.validator.destroy();
                            this.destroy();
                        }
                    }).data("kendoWindow").center().open();

                    scope.window.element.parent().css('z-index', '12001'); // common-service defines z-index of session-expired window of 12000

                    var formErrorTemplate = kendo.template(angular.element("#sessionExpiredFormErrorTemplate").html());
                    scope.validator = angular.element("#sessionExpiredForm").kendoValidator({
                        errorTemplate: formErrorTemplate,
                        messages: {
                            required: "Field is required"
                        }
                    }).data("kendoValidator");
                }();

                scope.login = function () {
                    if (!scope.validateForm()) {
                        return;
                    }

                    AuthService.login(scope.currentAccount.login, scope.password, scope.currentAccount.id,
                        function onSuccess() {
                            scope.window.close();
                            if (scope.promise) {
                                scope.promise.resolve();
                            }
                        },
                        function onError(responseError, response) {
                            scope.formErrors = [];
                            var errorMsg = responseError.message;
                            if (errorMsg) {
                                scope.formErrors.push(errorMsg);
                            }
                            angular.forEach(responseError.validationErrors, function (error) {
                                scope.formErrors.push(error);
                            });
                        });
                };

                scope.validateForm = function () {
                    return scope.validator.validate();
                };
            },
            templateUrl: UrlService.createAbsoluteUrl('/js/main/directives/templates/session-expired-template.html?ver=d089a2d1af9d4bd4b28e59540c825a3d')
        }
    }]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/directives/session-expired-directive.js
// module id = 200
// module chunks = 37